import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Upload, message, Typography } from 'antd';
import { PlusOutlined, InboxOutlined } from '@ant-design/icons';
import { useAssetActions } from '../../../../hooks/useAssets';
import { CreateAssetModalProps } from '../../../../types/asset.types';

const { Dragger } = Upload;
const { Text } = Typography;

// CreateAssetModalProps artık types'tan import ediliyor

const CreateAssetModal: React.FC<CreateAssetModalProps> = ({
  visible,
  onClose,
  onSuccess
}) => {
  const [form] = Form.useForm();
  const { createAsset, isLoading } = useAssetActions();
  const [fileList, setFileList] = useState<any[]>([]);

  useEffect(() => {
    if (visible) {
      form.resetFields();
      setFileList([]);
    }
  }, [visible, form]);

  const handleSubmit = async (values: any) => {
    try {
      // Dosyaları File array'ine dönüştür
      const files = fileList.map(file => file.originFileObj).filter(Boolean);
      
      await createAsset({
        name: values.name,
        serialNumber: values.serialNumber,
        files: files.length > 0 ? files : undefined
      });
      onSuccess();
      form.resetFields();
      setFileList([]);
    } catch (error) {
      console.error('Create asset failed:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setFileList([]);
    onClose();
  };

  // Dosya yükleme ayarları
  const uploadProps = {
    name: 'files',
    multiple: true,
    fileList,
    beforeUpload: () => false, // Otomatik yüklemeyi engelle
    onChange: (info: any) => {
      setFileList(info.fileList.slice(-5)); // Max 5 dosya
    },
    onDrop: (e: any) => {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  return (
    <Modal
      title={
        <div className="d-flex align-items-center">
          <div className="bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center me-3">
            <PlusOutlined className="text-white" style={{ fontSize: '18px' }} />
          </div>
          <div>
            <h5 className="mb-0">Yeni Zimmet Oluştur</h5>
            <Text type="secondary" className="small">Envantere yeni zimmet ekle</Text>
          </div>
        </div>
      }
      open={visible}
      onCancel={handleCancel}
      width={600}
      footer={null}
      destroyOnClose
    >
      <div className="create-asset-form">
        <div className="alert alert-info mb-4 d-flex align-items-center">
          <i className="ti ti-info-circle me-2 fs-5"></i>
          <div>
            <strong>Bilgi:</strong> Zimmet önce envantere eklenir, daha sonra çalışanlara atanabilir.
          </div>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            name="name"
            label="Zimmet Adı"
            rules={[
              { required: true, message: 'Zimmet adı gereklidir' },
              { min: 2, message: 'Zimmet adı en az 2 karakter olmalıdır' },
              { max: 100, message: 'Zimmet adı en fazla 100 karakter olmalıdır' }
            ]}
          >
            <Input 
              placeholder="Örn: MacBook Pro 14 M2" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="serialNumber"
            label="Seri Numarası"
            rules={[
              { required: true, message: 'Seri numarası gereklidir' },
              { min: 3, message: 'Seri numarası en az 3 karakter olmalıdır' },
              { max: 50, message: 'Seri numarası en fazla 50 karakter olmalıdır' }
            ]}
          >
            <Input 
              placeholder="Örn: C02G8R2JHD2" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="Dosyalar (İsteğe Bağlı)"
            help="Fatura, garanti belgesi vb. dosyaları yükleyebilirsiniz. (Maksimum 5 adet)"
          >
            <Dragger {...uploadProps} className="upload-area">
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Dosyaları buraya sürükleyin veya tıklayarak seçin
              </p>
              <p className="ant-upload-hint">
                PDF, DOC, JPG, PNG formatları desteklenir. Maksimum 5 dosya.
              </p>
            </Dragger>
          </Form.Item>

          <Form.Item className="mb-0">
            <div className="d-flex justify-content-end gap-2">
              <Button onClick={handleCancel} size="large">
                İptal
              </Button>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={isLoading}
                size="large"
                icon={<PlusOutlined />}
              >
                Envantere Ekle
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>

      <style>{`
        .upload-area {
          border: 2px dashed #d9d9d9;
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .upload-area:hover {
          border-color: #4096ff;
        }
        
        .create-asset-form .ant-form-item-label > label {
          font-weight: 600;
        }
      `}</style>
    </Modal>
  );
};

export default CreateAssetModal; 